/**
 * The Command Desk's `As Of HH:MM` stamp — RUN 82G, spec 01 §15 (gap S4).
 *
 * RUN 82C gave §8b's strip the stamp, as text. The second independent QA of the desk (L2) asked for
 * it in two more places — §8b's empty state, which is exactly the morning the Technical Delegate
 * wants to know how fresh the lock state is, and Today's Matches, whose crew chips are drawn from a
 * read of their own — and for the stamp to SAY when the refresh behind it has stopped landing. Three
 * places, one sentence: so it is one component, and the words and the class that turns it amber
 * cannot drift between panels.
 *
 * **Quietly.** A failing refresh keeps the last good answer on screen, and nothing about that answer
 * is wrong except its age. So the stamp is not a banner and not an alert — no `role`, nothing a
 * screen reader is interrupted by — it reads `As Of 11:02 · Refresh Failing` where the time was
 * already printed, and turns amber (spec 01 §15: *"turns amber past the configured threshold"*).
 * What `failing` means, and the ten minutes, are `readStamp`'s, in `derive.ts`.
 */

import type { ReadStamp } from "./derive.js";

export function AsOfStamp({
  stamp,
  testId,
}: {
  stamp: ReadStamp;
  /** Which panel's stamp this is, for a test to find. */
  testId: string;
}): React.JSX.Element {
  return (
    <span className={stamp.failing ? "asof asof--failing" : "asof"} data-testid={testId}>
      {stamp.label}
      {stamp.failing ? " · Refresh Failing" : null}
    </span>
  );
}
